export default {
  meta: {
    title: '选址模型配置',
    parentPath: ['/location'],
    breadcrumbs: {
      path: ['/location/locationmodel'],
      name: ['选址模型配置'],
    },
  },
};
